import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';
import { CandidateOpportunityDisplayBillingRates } from '@axiom/validation';

const OpportunitySubmissionCandidateRateFieldToCalculate = z.enum(
  ZodArrayToEnum([
    'proposedHourlyComp',
    'proposedMargin',
    'proposedHourlyBillRate',
  ])
);

export type OpportunitySubmissionCandidateRateFieldToCalculateType = z.infer<
  typeof OpportunitySubmissionCandidateRateFieldToCalculate
>;

export const OpportunitySubmissionCandidateRateSchema = z.object({
  displayBillingRate: z.enum(
    ZodArrayToEnum(CandidateOpportunityDisplayBillingRates)
  ),
  fieldToCalculate: OpportunitySubmissionCandidateRateFieldToCalculate,
  proposedHourlyComp: z.number().nullish(),
  proposedMargin: z.number().nullish(),
  proposedHourlyBillRate: z.number().nullish(),
});

export type OpportunitySubmissionCandidateRateSchemaType = z.infer<
  typeof OpportunitySubmissionCandidateRateSchema
>;
